import { useDispatch } from "react-redux";

import {
  setCreateCommunicationStatus,
  setDeleteCommunication,
  getCommunicationHistoryList,
  setUpdateCommunicationStatus,
  setTrafficStatusUpdate,
  getProfileData,
  updateProfileData,
  updateChiefsData,
  clearCommunicationCreateState,
  clearCommunicationDeleteState,
  clearCommunicationUpdateState,
  clearTrafficStatusUpdateState,
  clearProfileState,
  clearUpdateProfileState,
  clearUpdateChiefsState,
  clearCommunicationHistoryState,
  editEmailData,
  clearEditEmailState,
  getAdditionalInfoData,
  clearAdditionalInfoState,
  CommunicationCreatePayloadType,
  CommunicationHistoryPayloadType,
  CommunicationDeletePayloadType,
  TrafficStatusUpdatePayloadType,
  ProfilePayloadType,
  UpdateProfilePayloadType,
  UpdateProfileChiefsPayloadType,
  EditEmailPayloadType,
  getPreviewEmailSentData,
  clearPreviewEmailSentState
} from "./index";

export const useAffProfile = () => {
  const dispatch = useDispatch();

  const getCommunicationHistory = (data: CommunicationHistoryPayloadType) => dispatch(getCommunicationHistoryList(data))
  const createCommunicationStatus = (data: CommunicationCreatePayloadType) => dispatch(setCreateCommunicationStatus(data));
  const deleteCommunicationStatus = (data: CommunicationDeletePayloadType) => dispatch(setDeleteCommunication(data));
  const updateCommunicationStatus = (data: CommunicationCreatePayloadType) => dispatch(setUpdateCommunicationStatus(data));
  const updateTrafficStatus = (data: TrafficStatusUpdatePayloadType) => dispatch(setTrafficStatusUpdate(data));
  const getProfile = (data: ProfilePayloadType) => dispatch(getProfileData(data));
  const updateProfile = (data: UpdateProfilePayloadType) => dispatch(updateProfileData(data));
  const updateChiefs = (data: UpdateProfileChiefsPayloadType) => dispatch(updateChiefsData(data));
  const getPreviewEmailSent = (data: any) => dispatch(getPreviewEmailSentData(data));

  const editEmail = (data: EditEmailPayloadType) => dispatch(editEmailData(data));
  const clearEditEmail = () => dispatch(clearEditEmailState());

  const getAdditionalInfo = (data: any) => dispatch(getAdditionalInfoData(data));
  const clearAdditionalInfo = () => dispatch(clearAdditionalInfoState());

  const clearCommunicationCreate = () => dispatch(clearCommunicationCreateState());
  const clearCommunicationDelete = () => dispatch(clearCommunicationDeleteState());
  const clearCommunicationUpdate = () => dispatch(clearCommunicationUpdateState());
  const clearTrafficStatusUpdate = () => dispatch(clearTrafficStatusUpdateState());
  const clearProfileData = () => dispatch(clearProfileState());
  const clearUpdateProfileData = () => dispatch(clearUpdateProfileState());
  const clearUpdateChiefsData = () => dispatch(clearUpdateChiefsState());
  const clearCommunicationHistoryData = () => dispatch(clearCommunicationHistoryState());
  const clearPreviewEmailSent = () => dispatch(clearPreviewEmailSentState());



  return {
    getCommunicationHistory,
    createCommunicationStatus,
    deleteCommunicationStatus,
    updateCommunicationStatus,
    updateTrafficStatus,
    getProfile,
    updateProfile,
    updateChiefs,
    clearCommunicationCreate,
    clearCommunicationDelete,
    clearCommunicationUpdate,
    clearTrafficStatusUpdate,
    clearProfileData,
    clearUpdateProfileData,
    clearUpdateChiefsData,
    clearCommunicationHistoryData,
    editEmail,
    clearEditEmail,
    getAdditionalInfo,
    clearAdditionalInfo,
    getPreviewEmailSent,
    clearPreviewEmailSent,
  }
}
